module.exports = __webpack_public_path__ + "assets/img/37_1473_big.b13a3fa0.jpg";